export type PlantItem = {
    countryName: string,
    countrySid: string,
    fleetName: string,
    fleetSid: number,
    plantGroupName: string,
    plantGroupSid: number,
    plantName: string,
    plantSid: number
};

export type GetPowerPlantsResponse = {
    plants: PlantItem[]
};

export type Currency = {
    id: string,
    code: string
};

export type Country = {
    name: string,
    code: string,
    currency: Currency
};

export type PlantAttributesItem = {
    plantSId: string,
    name: string,
    plantGroupName: string,
    technology: string,
    technologySid: string,
    country: Country,
    units: {
        name: string,
        unitSid: string | number
    }[]
};

export type GetCurrencyPayload = {
    countryName: string
};
